import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useIsMobile } from '@hooks/useIsMobile';
import { ErrorBoundary } from '@components/ui/ErrorBoundary';
import { AppShellSidebar } from './AppShellSidebar';
import { AppShellTopBar } from './AppShellTopBar';
import { MobileSidebarDrawer } from './MobileSidebarDrawer';

export function AppShell() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();

  // Close the mobile drawer on every route change. NavLink onClick already
  // covers taps inside the drawer; this catches programmatic navigation.
  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  // If the viewport crosses to desktop while the drawer is open (rotation,
  // window resize) close it so the Drawer doesn't hover over the now-visible
  // desktop sidebar.
  useEffect(() => {
    if (!isMobile) setMobileNavOpen(false);
  }, [isMobile]);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-background text-foreground">
      <AppShellSidebar />
      <MobileSidebarDrawer
        open={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <AppShellTopBar onMobileMenuClick={() => setMobileNavOpen(true)} />
        <main className="flex-1 overflow-auto">
          <ErrorBoundary resetKey={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
